export const gameFeed = {
  gameFeed: "Game Feed",
  gameFeedTitle: "Game Feed",
  gameFeedLoading: "Loading game...",
  gameFeedLike: "Like",
  gameFeedUnlike: "Unlike",
  gameFeedLikeSingular: "like",
  gameFeedLikePlural: "likes",
  gameFeedComments: "Comments",
  gameFeedNoComments: "No comments yet. Be the first!",
  gameFeedAddComment: "Add a comment...",
  gameFeedCommentModerated:
    "Your comment was not posted because it goes against our platform policy. Please keep comments respectful.",
  gameFeedCommentSupportRedirect:
    "For withdrawal or payment inquiries, please contact our support team. This section is for game comments only.",
  gameFeedPost: "Post",
  gameFeedDelete: "Delete",
  gameFeedLoginToComment: "Log in to leave a comment",
  gameFeedLoginToLike: "Log in to like games",
  gameFeedReply: "Reply",
  gameFeedReplyPlaceholder: "Write a reply...",
  gameFeedViewReplies: "View replies ({{count}})",
  gameFeedViewMoreReplies: "View more replies",
  gameFeedHideReplies: "Hide replies",
  gameFeedEndOfFeed: "You've seen all the games!",
  gameFeedCloseGame: "Close game",
  gameFeedExpandGame: "Expand game to fullscreen",
  gameFeedDeposit: "Deposit",
  gameFeedBadgeHot: "Hot",
  gameFeedBadgeNew: "New",
  gameFeedBadgeBigWinner: "Big Win",
  providerProfileBack: "Back",
  providerProfileGames: "Games",
  providerProfileFollowers: "Followers",
  providerProfileFollow: "Follow",
  providerProfileFollowing: "Following",
  providerProfileGridView: "Grid view",
  providerProfileListView: "List view",
  providerProfileNoGames: "No games available from this provider yet.",
  providerProfileClose: "Close",
  providerProfilePlayGame: "Play game",
};
